/*!
 * devextreme-angular
 * Version: 26.1.5
 * Build date: Fri Sep 11 2026
 *
 * Copyright (c) 2012 - 2026 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/DevExtreme
 */

import { InjectionToken } from '@angular/core';

export const PROPERTY_TOKEN_items = new InjectionToken<string>('property-token-items');
export const PROPERTY_TOKEN_buttons = new InjectionToken<string>('property-token-buttons');
export const PROPERTY_TOKEN_toolbarItems = new InjectionToken<string>('property-token-toolbarItems');
export const PROPERTY_TOKEN_validationRules = new InjectionToken<string>('property-token-validationRules');
export const PROPERTY_TOKEN_changes = new InjectionToken<string>('property-token-changes');
export const PROPERTY_TOKEN_columns = new InjectionToken<string>('property-token-columns');
export const PROPERTY_TOKEN_customOperations = new InjectionToken<string>('property-token-customOperations');
export const PROPERTY_TOKEN_fields = new InjectionToken<string>('property-token-fields');
export const PROPERTY_TOKEN_tabs = new InjectionToken<string>('property-token-tabs');
export const PROPERTY_TOKEN_annotations = new InjectionToken<string>('property-token-annotations');
export const PROPERTY_TOKEN_breaks = new InjectionToken<string>('property-token-breaks');
export const PROPERTY_TOKEN_constantLines = new InjectionToken<string>('property-token-constantLines');
export const PROPERTY_TOKEN_panes = new InjectionToken<string>('property-token-panes');
export const PROPERTY_TOKEN_series = new InjectionToken<string>('property-token-series');
export const PROPERTY_TOKEN_strips = new InjectionToken<string>('property-token-strips');
export const PROPERTY_TOKEN_valueAxis = new InjectionToken<string>('property-token-valueAxis');
export const PROPERTY_TOKEN_alerts = new InjectionToken<string>('property-token-alerts');
export const PROPERTY_TOKEN_attachments = new InjectionToken<string>('property-token-attachments');
export const PROPERTY_TOKEN_typingUsers = new InjectionToken<string>('property-token-typingUsers');
export const PROPERTY_TOKEN_ranges = new InjectionToken<string>('property-token-ranges');
export const PROPERTY_TOKEN_groupItems = new InjectionToken<string>('property-token-groupItems');
export const PROPERTY_TOKEN_sortByGroupSummaryInfo = new InjectionToken<string>('property-token-sortByGroupSummaryInfo');
export const PROPERTY_TOKEN_totalItems = new InjectionToken<string>('property-token-totalItems');
export const PROPERTY_TOKEN_commands = new InjectionToken<string>('property-token-commands');
export const PROPERTY_TOKEN_connectionPoints = new InjectionToken<string>('property-token-connectionPoints');
export const PROPERTY_TOKEN_customShapes = new InjectionToken<string>('property-token-customShapes');
export const PROPERTY_TOKEN_groups = new InjectionToken<string>('property-token-groups');
export const PROPERTY_TOKEN_fileSelectionItems = new InjectionToken<string>('property-token-fileSelectionItems');
export const PROPERTY_TOKEN_stripLines = new InjectionToken<string>('property-token-stripLines');
export const PROPERTY_TOKEN_mentions = new InjectionToken<string>('property-token-mentions');
export const PROPERTY_TOKEN_menuItems = new InjectionToken<string>('property-token-menuItems');
export const PROPERTY_TOKEN_locations = new InjectionToken<string>('property-token-locations');
export const PROPERTY_TOKEN_markers = new InjectionToken<string>('property-token-markers');
export const PROPERTY_TOKEN_routes = new InjectionToken<string>('property-token-routes');
export const PROPERTY_TOKEN_cols = new InjectionToken<string>('property-token-cols');
export const PROPERTY_TOKEN_location = new InjectionToken<string>('property-token-location');
export const PROPERTY_TOKEN_rows = new InjectionToken<string>('property-token-rows');
export const PROPERTY_TOKEN_resources = new InjectionToken<string>('property-token-resources');
export const PROPERTY_TOKEN_views = new InjectionToken<string>('property-token-views');
export const PROPERTY_TOKEN_layers = new InjectionToken<string>('property-token-layers');
export const PROPERTY_TOKEN_legends = new InjectionToken<string>('property-token-legends');
export const PROPERTY_TOKEN_center = new InjectionToken<string>('property-token-center');
